/**
 * The steps of the Connect-a-device wizard, shared by the route (order + ids)
 * and the ConnectStepper (labels + icons). Plain data module so both the route
 * and the stepper import from one source of truth.
 *
 * Protocol (multi-protocol brief U3) sits between Discover and the point
 * picker: the scan pre-selects it, the operator can override it, and the
 * device's connection is set there.
 */

import {
  Boxes,
  Factory,
  ListTree,
  Plug,
  Radar,
  RadioTower,
  Wrench,
  type LucideIcon,
} from "lucide-react";

export type ConnectStepId =
  | "equipment"
  | "discover"
  | "protocol"
  | "registers"
  | "map"
  | "assign"
  | "golive";

export interface ConnectStepDef {
  id: ConnectStepId;
  label: string;
  icon: LucideIcon;
  hint: string;
}

export const CONNECT_STEPS: ConnectStepDef[] = [
  { id: "equipment", label: "Equipment", icon: Factory, hint: "Pick the equipment to feed" },
  { id: "discover", label: "Discover", icon: Radar, hint: "Find its device" },
  { id: "protocol", label: "Protocol", icon: Plug, hint: "How to talk to it" },
  { id: "registers", label: "Points", icon: ListTree, hint: "Pick what to read" },
  { id: "map", label: "Map", icon: Wrench, hint: "Point to tag" },
  { id: "assign", label: "Assign", icon: Boxes, hint: "Bind to its ports" },
  { id: "golive", label: "Go-live", icon: RadioTower, hint: "Push config and verify" },
];

export const CONNECT_STEP_ORDER: ConnectStepId[] = CONNECT_STEPS.map((s) => s.id);
